import React, { Component } from 'react';
import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing, Export, Grouping,
    GroupPanel,
    HeaderFilter, Pager,
    Paging,
    SearchPanel,
    SortByGroupSummaryInfo
}
    from 'devextreme-react/data-grid'; //npm install devextreme@19.1 devextreme-react@19.1
import { LoadPanel } from 'devextreme-react/load-panel';
import Modal from 'react-modal'; //npm install --save react-modal
import { StatusType, DateFormat, TripStatus } from '../../helpers/fixcodes';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { getRequestParams } from '../../helpers/globalfunctions.js';
import NumberFormat from 'react-number-format';
import NumericInput from 'react-numeric-input'; //npm install react-numeric-input --save
import Swal from 'sweetalert2';
import { SelectBox } from 'devextreme-react/select-box';
import RadioGroup from 'devextreme-react/radio-group';
import DateBox from 'devextreme-react/date-box';
import { formatDate } from '../../helpers/globalfunctions';
import moment from 'moment/min/moment-with-locales';//npm install --save moment react-moment
import { HotelServiceTransferComponent } from './HotelServiceTransferComponent';
import { PageLoaderComponent } from "../Shared/PageLoaderComponent";

const position = { of: '#historydiv' };

let currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
let currentExactTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
//console.log(currentTime);
//console.log(currentTime.setMinutes(currentTime.getMinutes() + 20).format("MM/DD/YYYY HH:mm"));
//console.log(moment().add(7, 'minutes').format("MM/DD/YYYY HH:mm"));
currentTime.setMinutes(currentTime.getMinutes() + 20);
let defaultCurrentTime = moment(currentTime).format("HH:mm");
//console.log("defaultCurrentTime: " + defaultCurrentTime);

let currentHour = 0;
let currentMinute = 0;

export const rideTypeEntities = [
    { id: 1, text: 'Airport' },
    { id: 2, text: 'Hotel' },
];

export const rideDayEntities = [
    { id: 1, text: 'Today' },
    { id: 2, text: 'Tomorrow' },
];

function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function renderSuggestion(suggestion) {
    if (suggestion.isNotFound) {
        return (
            <span>
                Data not found!
            </span>
        );
    }
    return (
        <span>{suggestion.name}</span>
    );
}
function shouldRenderSuggestions(value, reason) {
    return value.trim().length > 2;
}

export class HotelCustomerTransferComponent extends Component {
    static displayName = HotelCustomerTransferComponent.name;

    constructor(props) {
        currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
        currentExactTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
        currentTime.setMinutes(currentTime.getMinutes() + 20);
        currentHour = new Date(currentTime).getHours();
        currentMinute = new Date(currentTime).getMinutes();

        super(props);
        this.state = {
            isOpenModal: false,
            loadingMessage: "Loading ...",
            htCustomerToken: sessionStorage.getItem("session_htCustomerToken"),
            customerId: parseInt(sessionStorage.getItem("session_accountId")),
            parentAccountId: parseInt(sessionStorage.getItem("session_parentAccountId")),
            customerName: sessionStorage.getItem("session_accountname"),
            stopId: parseInt(sessionStorage.getItem("session_stop_id")),
            hotelId: parseInt(sessionStorage.getItem("session_hotel_id")),
            hotelCode: sessionStorage.getItem("session_hotel_code"),
            isSubmited: false,
            isSaveSubmited: false,
            isRezSaveSubmited: false,
            passengerdatasource: null,
            rideId: 0,
            pageName: '',
            loadPanelVisible: false,
            refreshRideSource: props.refreshDataSource,
            handleRefresh: props.handleRefresh,
            allowSocketConnection: sessionStorage.getItem("session_allowSocketConnection") === "true" ? true : false,
            rowIndex: 0,
            paxFirstName: "",
            paxLastName: "",
            mobileNumber: "",
            email: "",
            noOfPax: "",
            isPaxUpdate: false,
            shuttleScheduleSource: [],
            scheduleId: 0,
            scheduleTime: "",
            puDateTime: currentTime,
            actualPuTime: moment(currentTime).format('HH:mm'),
            routeSchedulesGroupId: 0,
            scheduleActualPickupTime: [],
            stopScheduleId: 0,

            rideId: 0,
            customer: [],
            flightTime: new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), currentHour, currentMinute),
            flightHour: currentHour,
            flightMinute: currentMinute,
            flightNumberReturn: '',
            terminalTypeReturn: 0,
            terminalReturn: '',
            flightTimeReturn: new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), currentHour, currentMinute),
            flightHourReturn: currentHour,
            flightMinuteReturn: currentMinute,

            serviceSourceId: 1,
            otherAffiliateId: 0,
            isVipTrip: false,
            isPriorityTrip: false,
            isMeetGreet: false,
            tripTypeId: "1",
            puDateTime: currentTime,
            puDateTimeReturn: currentTime,
            specialInstruction: "",
            orderByName: sessionStorage.getItem("session_name"),
            countryCodeOrderPhone: '',
            phoneNumberOrder: '',
            emailOrder: '',
            dropdownReservationMode: [],
            reservationModeId: 0,
            puDateTime: currentTime,
            puDateTimeReturn: currentTime,
            doDateTime: currentTime,
            tripDuration: 0,
            dropdownVehicleType: [],
            vehicleTypeId: 0,
            noOfPax: 1,
            noOfPaxReturn: 1,
            luggage: 0,
            noOfTrip: 1,
            isAccessible: false,
            isVipTrip: false,
            isPriorityTrip: false,
            isMeetGreet: false,
            tripTypeId: "1",
            recurringTypeId: 2,
            recurringEndDate: "",
            selectedDays: [],
            isWeekSun: false,
            isWeekMon: false,
            isWeekTue: false,
            isWeekWed: false,
            isWeekThu: false,
            isWeekFri: false,
            isWeekSat: false,
            isMonthSun: false,
            isMonthMon: false,
            isMonthTue: false,
            isMonthWed: false,
            isMonthThu: false,
            isMonthFri: false,
            isMonthSat: false,
            specialInstruction: "",
            permanentRemark: "",
            pickupNotes: "",
            billToNotes: "",
            customerRateTax: null,
            loadPanelVisible: false,
            isCopy: false,
            isAttachment: false,
            scheduleTime: "",
            scheduleId: 0,
            pickupZoneTypeId: 0,
            dropoffZoneTypeId: 0,
            schReservationId: 0,
            rideTypeId: 2,
            rideDayId: 1,
            dropdownZone: [],
            accountDetails: [],
            isSendEmail: false,
            pickupTime: "",
            isBookingSaved: false,
            bookingMessage: "",
            defaultCurrentTime: defaultCurrentTime,
            placeGridDataSource: [],
            pickupLocationId: 0,
            pickupLocationSource: [],
            dropdownCustomer: [],
            isSuccess: false,

            errors: {
                paxFirstName: "",
                paxLastName: "",
                mobileNumber: "",
                email: "",
                noOfPax: "",
                scheduleTime: "",
                puDateTime: "",
                pickupTime: "",
                pickupLocationId: "",
            }
        }

        this.getCustomerList = this.getCustomerList.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePaxCountChange = this.handlePaxCountChange.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.hotelPaxDetailsSubmit = this.hotelPaxDetailsSubmit.bind(this);
        this.handleEditAddPassenger = this.handleEditAddPassenger.bind(this);
        this.handleBookReservation = this.handleBookReservation.bind(this);
        this.getVehicleType = this.getVehicleType.bind(this);
        this.getZones = this.getZones.bind(this);
        this.getBookingSuggestions = this.getBookingSuggestions.bind(this);
        this.getAirportSuggestions = this.getAirportSuggestions.bind(this);
        this.getRideOnScheduleActualPickupTime = this.getRideOnScheduleActualPickupTime.bind(this);
        this.getRidePassengerDetails = this.getRidePassengerDetails.bind(this);
        this.handleCancelPassenger = this.handleCancelPassenger.bind(this);
        this.getServiceAreaZoneList = this.getServiceAreaZoneList.bind(this);
        this.handlePickupChange = this.handlePickupChange.bind(this);
        //this.getAllCustomerList = this.getAllCustomerList.bind(this);
        //this.handleCustomerChange = this.handleCustomerChange.bind(this);
    };

    async componentDidMount() {
        this.setState({
            loadPanelVisible: true
        });

        let suggestionValue = this.state.customerName.substring(0, 5);
        await this.getCustomerList();
        await this.getVehicleType();
        await this.getZones();
        await this.getRidePassengerDetails(0, this.state.rideDayId);
        await this.getRideOnScheduleActualPickupTime(this.state.rideDayId);
        await this.getBookingSuggestions(this.state.customerName);
        //await this.getServiceAreaZoneList();
        //await this.getAllCustomerList();

        this.setState({
            loadPanelVisible: false
        });
    }

    clearControls() {
        this.setState({
            rideId: 0,
            paxFirstName: "",
            paxLastName: "",
            mobileNumber: "",
            email: "",
            noOfPax: "",
            rowIndex: 0,
            paxFirstName: "",
            paxLastName: "",
            mobileNumber: "",
            email: "",
            noOfPax: "",
            isPaxUpdate: false,
            scheduleId: 0,
            scheduleTime: "",
            puDateTime: currentTime,
            routeSchedulesGroupId: 0,
            //scheduleActualPickupTime: [],
            stopScheduleId: 0,
            pickupTime: "",
            pickupLocationId: 0,
            pickupLocationSource: [],
            rideTypeId: 2,
            rideDayId: 1,

            errors: {
                paxFirstName: "",
                paxLastName: "",
                mobileNumber: "",
                email: "",
                noOfPax: "",
                scheduleTime: "",
                puDateTime: "",
                pickupTime: "",
                pickupLocationId: "",
            }
        });
    }

    clearGridControls() {
        this.setState({
            rideId: 0,
            paxFirstName: "",
            paxLastName: "",
            mobileNumber: "",
            email: "",
            noOfPax: "",
            rowIndex: 0,
            paxFirstName: "",
            paxLastName: "",
            mobileNumber: "",
            email: "",
            noOfPax: "",
            isPaxUpdate: false,
            scheduleId: 0,
            scheduleTime: "",
            puDateTime: currentTime,
            passengerdatasource: [],
            routeSchedulesGroupId: 0,
            //scheduleActualPickupTime: [],
            stopScheduleId: 0,
            pickupTime: "",
            pickupLocationId: 0,
            pickupLocationSource: [],

            errors: {
                paxFirstName: "",
                paxLastName: "",
                mobileNumber: "",
                email: "",
                noOfPax: "",
                scheduleTime: "",
                pickupTime: "",
                pickupLocationId: "",
            }
        });
    }

    //async getAllCustomerList() {
    //    let customerList = [];
    //    const data = JSON.parse(sessionStorage.getItem("session_customers"));
    //    debugger;
    //    if (data === null) {
    //        const requestParams = getRequestParams('GET', '');
    //        const response = await fetch('account-api/customer-dropdown/', requestParams);
    //        const data = await response.json();
    //        customerList = data.customers.filter(e => e.customerTypeId === 5);
    //        this.setState({
    //            dropdownCustomer: data.customers,
    //        });
    //    }
    //    else {
    //        customerList = data.customers.filter(e => e.customerTypeId === 5);
    //        this.setState({
    //            dropdownCustomer: data.customers
    //        });
    //    }
    //}

    async getVehicleType() {
        try {
            var newObject = new Object();
            //newObject.AccountId = this.state.parentAccountId === 1 ? this.state.customerId : this.state.parentAccountId;
            newObject.AccountId = this.state.parentAccountId;
            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('vehicletype-api/vehicletype', requestParams);
            const data = await response.json();
            let vehicleType = data.apiVehicleType.filter(f => f.vehicleTypeCode === "VAN");
            this.setState({
                vehicleTypeId: vehicleType[0].rowIndex
            });
        } catch (e) {
            console.log(e);
        }
    }

    async getZones() {
        try {
            //console.log(this.state.parentAccountId);
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('serviceAreaZone-api/zone-dropdown/' + this.state.parentAccountId + '/' + 0 + "/" + 0, requestParams);
            //const response = await fetch('serviceAreaZone-api/zone-dropdown/' + 0 + "/" + 0, requestParams);
            const data = await response.json();
            this.setState({
                dropdownZone: data.locationServiceAreaZoneList,
            });
        } catch (e) {
            console.log(e);
        }
    }

    async getBookingSuggestions(value) {
        const escapedValue = escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return [];
        }

        const requestParams = getRequestParams('GET', '');
        const response = await fetch('address-search-api/' + this.state.parentAccountId + '/' + this.state.customerId + '/5/' + value, requestParams);
        //const response = await fetch('address-search-api/' + this.state.customer.id + '/' + this.state.customerId + '/5/' + value, requestParams);
        const data = await response.json();

        this.setState({ bookingAddress: data === false ? [] : data.addressSearchList })

        const regex = new RegExp('^' + escapedValue, 'i');

        //const suggestions = (this.state.bookingAddress.length > 0) ? this.state.bookingAddress.filter(bookingAddress => regex.test(bookingAddress.name)) : [];
        const suggestions = (data === false) ? [] : data.addressSearchList;
        if (suggestions.length === 0) {
            return [
                { isNotFound: true }
            ];
        }        
        this.getDropffSuggestionValue(suggestions);
    }

    getPickupSuggestionValue(newsuggestion) {
        if (newsuggestion.isNotFound) {
            return "";
        }        
        let suggestion = newsuggestion[0];
        let pickupZone = this.state.dropdownZone?.filter(f => f.id === suggestion.zoneId);

       

        this.setState({
            pickupLocation: suggestion.name,
            pickupAddress: suggestion.address,
            pickupAddressType: suggestion.addressType,
            pickupCity: suggestion.city,
            pickupState: suggestion.state,
            pickupZipCode: suggestion.zipCode,
            pickupZoneId: suggestion.zoneId,
            pickupLatitude: suggestion.latitude,
            pickupLongitude: suggestion.longitude,
            pickupZoneTypeId: pickupZone[0].zoneTypeId,
        });

        //if (this.state.dropdownZone.findIndex(opt => opt.id == suggestion.zoneId) < 0) {
        //    this.setState({
        //        pickupZoneId: 0,
        //    });
        //} else {
        //    this.getRideTypeId(suggestion.zoneId, this.state.dropoffZoneId);
        //    this.getCustomerRateTaxSetting(suggestion.id, this.state.dropoffZoneId, this.state.puDateTime, this.state.vehicleTypeId, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet);         
        //}
    }

    async getAirportSuggestions(value) {
        const escapedValue = escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return [];
        }        
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('address-search-api/' + this.state.parentAccountId + '/' + this.state.customerId + '/5/' + value, requestParams);
        //const response = await fetch('address-search-api/' + this.state.customer.id + '/' + this.state.customerId + '/5/' + value, requestParams);
        const data = await response.json();        
        this.setState({ bookingAddress: data === false ? [] : data.addressSearchList })

        const regex = new RegExp('^' + escapedValue, 'i');

        //const suggestions = (this.state.bookingAddress.length > 0) ? this.state.bookingAddress.filter(bookingAddress => regex.test(bookingAddress.name)) : [];
        const suggestions = (data === false) ? [] : data.addressSearchList;
        if (suggestions.length === 0) {
            return [
                { isNotFound: true }
            ];
        }

        this.getPickupSuggestionValue(suggestions);
    }

    getDropffSuggestionValue(newsuggestion) {
        if (newsuggestion.isNotFound) {
            return "";
        }

        console.log("newsuggestion: " + JSON.stringify(newsuggestion));
        let suggestion = newsuggestion.filter(e => e.code === this.state.hotelCode)[0];
        console.log("suggestion: " + JSON.stringify(suggestion));
        //let dropoffZone = this.state.dropdownZone?.filter(f => f.id === suggestion.zoneId);

        this.setState({
            dropoffLocation: suggestion.name,
            dropoffAddress: suggestion.address,
            dropoffAddressType: suggestion.addressType,
            dropoffCity: suggestion.city,
            dropoffState: suggestion.state,
            dropoffZipCode: suggestion.zipCode,
            dropoffZoneId: suggestion.zoneId,
            dropoffLatitude: suggestion.latitude,
            dropoffLongitude: suggestion.longitude
        });

        //if (this.state.dropdownZone.findIndex(opt => opt.id == suggestion.zoneId) < 0) {
        //    this.setState({
        //        pickupZoneId: 0,
        //    });
        //} else {
        //    this.getRideTypeId(suggestion.zoneId, this.state.dropoffZoneId);
        //    this.getCustomerRateTaxSetting(suggestion.id, this.state.dropoffZoneId, this.state.puDateTime, this.state.vehicleTypeId, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet);         
        //}
    }

    async getRidePassengerDetails(rideId, rideDayId) {
        try {
            this.setState({
                loadPanelVisible: true
            });

            var request = {};
            request.Id = 0;
            request.RideId = 0;
            request.PuStopId = this.state.stopId;
            request.PuDateTime = moment(this.state.puDateTime).format("MM/DD/YYYY 00:00:00");
            const requestParams = getRequestParams('POST', request);
            //const response = await fetch('reservation-api/' + reservationId + '/paxDetails/' + (rideId !== undefined ? rideId : 0) + '/' + this.state.stopId, requestParams);
            const response = await fetch('reservation-api/PaxDetails', requestParams);
            const data = await response.json();

            this.setState({
                passengerdatasource: data?.ridePassengerDetails,
                loadPanelVisible: false
            });

        } catch (e) {
            console.log(e);
        }
    }

    async getShuttleSchedule() {
        try {
            var request = {};
            request.ShuttleRouteSchedule = new Object();
            request.ShuttleRouteSchedule.ScheduleId = parseInt(0);
            request.ShuttleRouteSchedule.RouteId = parseInt(0);
            request.ShuttleRouteSchedule.ReservationId = parseInt(0);
            request.ShuttleRouteSchedule.CustomerId = parseInt(6054); //this.state.customerId; this.state.customer.id;
            request.ShuttleRouteSchedule.SchedulesGroupId = parseInt(this.state.customer.routeGroupId); //this.state.customer.routeGroupId;
            const requestParamsSchedule = getRequestParams('POST', request);
            const responseSchedule = await fetch('/shuttle-schedule-api/details', requestParamsSchedule);
            const dataSchedule = await responseSchedule.json();
            //console.log(dataSchedule);
            this.setState({
                shuttleScheduleSource: dataSchedule.shuttleRouteSchedule ?? []
            })
        } catch (e) {
            console.log(e);
        }
    }

    //async getScheduleActualPickupTime() {
    //    try {
    //        var request = {};
    //        request = new Object();
    //        request.RowIndex = parseInt(0);
    //        request.RouteScheduleId = parseInt(0);
    //        request.RouteStopId = this.state.stopId;
    //        request.ScheduleGroupId = parseInt(6054); //this.state.customerId; this.state.customer.id;
    //        request.ScheduleTime = this.state.scheduleTime; //this.state.customer.routeGroupId;
    //        const requestParamsSchedule = getRequestParams('POST', request);
    //        const responseSchedule = await fetch('/shuttle-schedule-api/details', requestParamsSchedule);
    //        const dataSchedule = await responseSchedule.json();
    //        console.log(dataSchedule);
    //        this.setState({
    //            shuttleScheduleSource: dataSchedule.shuttleRouteSchedule ?? []
    //        })
    //    } catch (e) {
    //        console.log(e);
    //    }
    //}

    async getCustomerList() {
        let customerList = [];
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('account-api/single-customer/', requestParams);
        const data = await response.json();
        customerList = data?.customers[0];
        this.setState({
            customer: customerList,
        });
    }

    //async getParentAccountDetails(id) {
    //    debugger;
    //    let accountList = [];
    //    const requestParams = getRequestParams('GET', '');
    //    const response = await fetch('customer-api/list/ '+ id, requestParams);
    //    const data = await response.json();
    //    accountList = data?.customers[0];
    //    this.setState({
    //        accountDetails: accountList[0],
    //    });
    //}

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        this.state.errors[name] = "";
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.scheduleTime = "";
        errors.paxFirstName = "";
        errors.paxLastName = "";
        errors.mobileNumber = "";
        errors.email = "";
        errors.noOfPax = "";
        errors.pickupTime = "";
        errors.pickupLocationId = "";

        if (this.state.rideTypeId === 2) {
            if (this.state.stopScheduleId === 0) {
                formIsValid = false;
                errors.pickupTime = "Please select pickup time.";
            }
        }
        if (this.state.rideTypeId === 1) {
            if (this.state.pickupLocationId === 0) {
                formIsValid = false;
                errors.pickupLocationId = "Please select pickup location.";
            }
        }
        if (this.state.paxFirstName.trim() === '') {
            formIsValid = false;
            errors.paxFirstName = "Please enter pax first name.";
        }
        if (this.state.paxLastName.trim() === '') {
            formIsValid = false;
            errors.paxLastName = "Please enter pax last name.";
        }
        if (this.state.mobileNumber.trim() === "") {
            formIsValid = false;
            errors.mobileNumber = "Please enter mobile.";
        } else if (this.state.mobileNumber.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length != 10) {
            formIsValid = false;
            errors.mobileNumber = "Invalid mobile number.";
        }
        if (parseInt(this.state.noOfPax | 0) == 0) {
            formIsValid = false;
            errors.noOfPax = "Please enter no of pax.";
        }
        else if (parseInt(this.state.noOfPax | 0) > 60) {
            formIsValid = false;
            errors.noOfPax = "Please enter no of pax less than 60.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    //handleCustomerChange(data) {
    //    if (data.selectedItem === null) {
    //        this.setState({
    //            customer: null
    //        });
    //        return;
    //    }

    //    this.setState({
    //        customer: data.selectedItem,
    //        customerId: data.selectedItem.id
    //    });
    //}

    handlePaxCountChange(value) {
        this.setState({ noOfPax: value });
        if (value > 0) {
            this.state.errors["noOfPax"] = ""
        }
    }

    async hotelPaxDetailsSubmit() {
        if (!this.handleValidation()) {
            return;
        }

        //var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
        //var pickupDate = [];
        //pickupDate.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1)
        //    : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0"
        //        + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear() + " " + this.state.pickupTime);

        var stpuDate = new Date(this.state.puDateTime);
        var stnewpuDate = new Date(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1)
            : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0"
                + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear() + " " + this.state.pickupTime);

        //var pickupDate = [];
        //pickupDate.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1)
        //    : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0"
        //        + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear() + " " + this.state.pickupTime);
        
        var pickupDate = [];
        var stpuDate = moment(new Date(stnewpuDate)).format(DateFormat.MomentDisplayDateTime24Format);
        pickupDate.push(stpuDate);

        var newObject = new Object();
        let paxCount = (parseInt(this.state.noOfPax | 0));
        newObject.rowIndex = this.state.rowIndex;
        newObject.accountId = this.state.customer.id;
        newObject.rideId = this.state.rideId;
        newObject.paxCount = paxCount;
        newObject.paxFirstName = this.state.paxFirstName;
        newObject.paxLastName = this.state.paxLastName;
        newObject.mobile = this.state.mobileNumber;
        newObject.email = this.state.email;
        newObject.pax = paxCount;
        newObject.puStopId = this.state.stopId;
        newObject.doStopId = parseInt(0);
        newObject.createdBy = parseInt(sessionStorage.getItem("session_userId"));
        newObject.pickupDateTime = pickupDate[0];
        newObject.isCancelled = false;

        const requestParams = getRequestParams('POST', newObject);
        const response = await fetch('reservation-api/addEditPassengerDetails', requestParams);
        const data = await response.json();

        this.setState({
            isSaveSubmited: false,
            isBookingSaved: true,
            bookingMessage: data.resultMessage,
            isSuccess: data.isSuccess,
        });

        //Swal.fire({
        //    icon: data.isSuccess ? 'success' : 'error',
        //    title: data.isSuccess ? 'Success' : 'Oops...',
        //    html: data.resultMessage,
        //    width: '25%',
        //    allowOutsideClick: false
        //}).then((result) => {
        //    /* Read more about isConfirmed, isDenied below */
        //    if (data.isSuccess) {
        //        if (result.isConfirmed) {
        //            this.getRidePassengerDetails(this.state.rideId);
        //            this.clearControls();
        //        }
        //    }            
        //});
    }

    async handleBookReservation(e) {
        if (!this.handleValidation()) {
            return;
        }

        e.preventDefault();

        let paxCount = (parseInt(this.state.noOfPax | 0));

        // var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
        //pickupDate.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0" + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
        //var stpuDate = moment(new Date(this.state.puDateTime)).format("MM/DD/yyyy HH:mm");
        var pickupDate = [];
        var stpuDate = moment(new Date(this.state.puDateTime)).format(DateFormat.MomentDisplayDateTime24Format);
        pickupDate.push(stpuDate);
        //Get Ride Type Zone Ids.
        let fromAreaId = 0, toAreaId = 0, pickupLocationType = "", dropoffLocationType = "";

        let rideTypeId = this.state.rideTypeId;
        let puZone = this.state.dropdownZone.find(opt => opt.zoneTypeId == 1);
        let doZone = this.state.dropdownZone.find(opt => opt.zoneTypeId == 3);

        if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
            fromAreaId = puZone.airportId;
            toAreaId = doZone.id;
            pickupLocationType = "AIRPORT";
            dropoffLocationType = "HOTEL";

        } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
            fromAreaId = puZone.id;
            toAreaId = doZone.airportId;
            pickupLocationType = "HOTEL";
            dropoffLocationType = "AIRPORT";
        } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
            fromAreaId = puZone.airportId;
            toAreaId = doZone.airportId;
            pickupLocationType = "AIRPORT";
            dropoffLocationType = "AIRPORT";
        } else {
            fromAreaId = puZone.id;
            toAreaId = doZone.id;
            pickupLocationType = "HOTEL";
            dropoffLocationType = "HOTEL";
        }

        //pickupLocationType = "AIRPORT";
        //dropoffLocationType = "HOTEL";

        //let airlines = this.state.dropdownAirline.find(opt => opt.airLineId == this.state.airlineId);

        var newObject = new Object();
        newObject.reservationId = 0;
        newObject.rideId = this.state.rideId;
        newObject.userGuid = "HOTELCUSTOMER";
        newObject.parentAccountId = this.state.parentAccountId;

        newObject.rideTypeId = rideTypeId;
        newObject.fromAreaId = fromAreaId; //
        newObject.toAreaId = toAreaId; //
        newObject.paxCount = paxCount;
        newObject.paxCountReturn = 0;
        newObject.baggage = 0;

        newObject.firstName = this.state.paxFirstName;
        newObject.lastName = this.state.paxLastName;
        newObject.firstNameReturn = "";
        newObject.lastNameReturn = "";

        newObject.countryCode = "+1";
        newObject.phoneNo = this.state.mobileNumber;
        newObject.cellCountryCode = "+1";
        newObject.mobileNo = this.state.mobileNumber;

        newObject.customerId = parseInt(this.state.customerId);
        newObject.airlineId = 0;
        newObject.flightNumber = "";
        //newObject.flightTime = this.state.flightTime.toLocaleTimeString();
        //newObject.flightTime = new Date(this.state.flightTime.getFullYear(), this.state.flightTime.getMonth(), this.state.flightTime.getDate(), this.state.flightHour, this.state.flightMinute).toLocaleTimeString();
        //newObject.flightTime = this.state.flightTime.toLocaleDateString() + " " + this.state.flightTime.toLocaleTimeString();
        //newObject.flightTime = moment(new Date(this.state.flightTime)).format(DateFormat.MomentDisplayDateTime24Format);
        newObject.terminalType = 0;
        newObject.terminal = "";
        newObject.airlineIdReturn = 0;
        newObject.flightNumberReturn = this.state.flightNumberReturn;
        //newObject.flightTimeReturn = this.state.flightTimeReturn.toLocaleTimeString();
        //newObject.flightTimeReturn = new Date(this.state.flightTimeReturn.getFullYear(), this.state.flightTimeReturn.getMonth(), this.state.flightTimeReturn.getDate(), this.state.flightHourReturn, this.state.flightMinuteReturn).toLocaleTimeString();
        //newObject.flightTimeReturn = this.state.flightTimeReturn.toLocaleDateString() + " " + this.state.flightTimeReturn.toLocaleTimeString();
        newObject.flightTimeReturn = moment(new Date(this.state.flightTimeReturn)).format(DateFormat.MomentDisplayDateTime24Format);        
        newObject.terminalTypeReturn = 0;
        newObject.terminalReturn = "";
        newObject.email = this.state.email;
        newObject.poNumber = "";
        newObject.isPickupGoogleBooking = false;
        newObject.pickupLocation = this.state.pickupLocation;
        newObject.pickupLocationType = pickupLocationType;
        newObject.pickupAddress = this.state.pickupAddress;
        newObject.pickupCity = this.state.pickupCity;
        newObject.pickupState = this.state.pickupState;
        newObject.pickupZipCode = this.state.pickupZipCode;
        newObject.pickupLatitude = this.state.pickupLatitude;
        newObject.pickupLongitude = this.state.pickupLongitude;
        newObject.pickupGeoZoneId = puZone != null ? puZone.id : 0;
        newObject.pickupIsHotel = puZone != null ? (puZone.zoneTypeId === 3 ? true : false) : false;
        newObject.pickupHotelId = 0;

        newObject.isDropoffGoogleBooking = false;
        newObject.dropoffLocation = this.state.dropoffLocation;
        newObject.dropoffLocationType = dropoffLocationType;
        newObject.dropoffAddress = this.state.dropoffAddress;
        newObject.dropoffCity = this.state.dropoffCity;
        newObject.dropoffState = this.state.dropoffState;
        newObject.dropoffZipCode = this.state.dropoffZipCode;
        newObject.dropoffLatitude = this.state.dropoffLatitude;
        newObject.dropoffLongitude = this.state.dropoffLongitude;
        newObject.dropoffGeoZoneId = doZone != null ? doZone.id : 0;
        newObject.dropoffIsHotel = doZone != null ? (doZone.zoneTypeId === 3 ? true : false) : false;
        newObject.dropoffHotelId = this.state.hotelId;

        newObject.apt = this.state.apt;

        newObject.serviceSourceId = parseInt(this.state.serviceSourceId);
        newObject.serviceSourceName = (parseInt(this.state.serviceSourceId) == 1) ? "In House" : ((parseInt(this.state.serviceSourceId) == 2) ? "Farm In" : "Farm Out");
        newObject.otherAffiliateId = parseInt(this.state.otherAffiliateId);
        newObject.isVipTrip = this.state.isVipTrip;
        newObject.isMeetGreet = this.state.isMeetGreet;
        newObject.isAccessible = this.state.isAccessible;
        newObject.isPriority = this.state.isPriorityTrip;
        newObject.pickupDateArray = pickupDate;
        newObject.pickupTime = this.state.puDateTime.toLocaleTimeString();
        //newObject.pickupTimeReturn = this.state.puDateTimeReturn.toLocaleTimeString();
        //newObject.pickupDateReturn = this.state.puDateTimeReturn.toLocaleDateString();
        newObject.pickupTimeReturn = moment(new Date(this.state.puDateTimeReturn)).format(DateFormat.DefaultTimeFormat);
        newObject.pickupDateReturn = moment(new Date(this.state.puDateTimeReturn)).format(DateFormat.MomentDisplayDateTime24Format);
        newObject.apiVehicleTypeId = parseInt(this.state.vehicleTypeId);
        newObject.tripTypeId = parseInt(this.state.tripTypeId);
        newObject.specialInstruction = this.state.specialInstruction;
        newObject.permanentRemark = this.state.permanentRemark;
        newObject.pickupNotes = this.state.pickupNotes;
        newObject.billToNotes = this.state.billToNotes;

        newObject.orderByName = this.state.orderByName;
        newObject.orderByCountryCode = this.state.countryCodeOrderPhone;
        newObject.orderByPhone = this.state.phoneNumberOrder;
        newObject.orderByEmail = this.state.emailOrder;
        newObject.approxDropoffTime = this.state.doDateTime;
        newObject.approxTripDurationMin = parseInt(this.state.tripDuration);
        newObject.reservationModeId = parseInt(this.state.reservationModeId);
        newObject.vehicleId = 0;
        newObject.driverId = 0;

        newObject.pilotCount = 0;
        newObject.crewCount = 0;
        newObject.flightAttandCount = 0;
        newObject.pilotCountReturn = 0;
        newObject.crewCountReturn = 0;
        newObject.flightAttandCountReturn = 0;

        newObject.rateId = 0; //this.state.customerRateTax.rateId;
        newObject.paymentTypeId = 1;
        newObject.voucherNo = "";
        newObject.voucherCompany = 0;
        newObject.chqBankName = "";
        newObject.chqNumber = "";
        newObject.chqDate = "";

        newObject.creditCardNumber = "";
        newObject.creditCardExpiry = "";
        newObject.cardType = "";

        newObject.transferTypeId = 1;
        newObject.serviceTypeId = 2;

        newObject.rideAmount = parseFloat(0);
        newObject.tollAmnt = parseFloat(0);
        newObject.tipAmnt = parseFloat(0);
        newObject.meetGreetCharge = parseFloat(0);
        newObject.payToTourGuide = 0.00;
        newObject.tourGuideName = "";
        newObject.tourGuideCharge = 0.00;
        newObject.mgPayTo = 2 // 1 => Pay To Greeter, 2 => 100% to Company, 3 => Pay to Driver;
        newObject.meetGreetId = 0;
        newObject.meetGreetName = "";
        newObject.meetGreetAmount = 0.00;
        newObject.mgDriverComms = false;
        newObject.gratuity = "";
        newObject.stop = parseFloat(0);
        newObject.noOfStop = 0;
        newObject.wtTotal = 0.00;
        newObject.wtTime = 0;
        newObject.wt = parseFloat(0);
        newObject.ot = 0.00;
        newObject.serviceFee = parseFloat(0);
        newObject.fuelSurCharge = parseFloat(0);
        newObject.parking = parseFloat(0);
        newObject.portAuthority = parseFloat(0);
        newObject.utilityTax = parseFloat(0);
        newObject.wcTax = parseFloat(0);
        newObject.salesTax = parseFloat(0);
        newObject.countyTax = parseFloat(0);
        newObject.congestionTax = parseFloat(0);
        newObject.extraAmnt = 0.00;
        newObject.extraAmntFor = "";
        newObject.gross = parseFloat(0);
        newObject.discount = parseFloat(0);
        newObject.totalFare = parseFloat(0);
        newObject.billableFare = parseFloat(0);
        newObject.totalPaid = 0.00;
        newObject.chargeTo = "";
        newObject.agentName = "";
        newObject.agentId = 0;
        newObject.agentCommission = parseFloat(0);

        newObject.partialPay = false;
        newObject.rateLocked = false;
        newObject.currencyId = 0;
        newObject.exchangeRate = 0;
        newObject.totalTax = 0;
        newObject.GratuityAmount = 0;

        newObject.tripChangesLogs = "";

        var paxDetails = {};
        paxDetails.RideId = 0;
        paxDetails.PaxFirstName = this.state.paxFirstName;
        paxDetails.PaxLastName = this.state.paxLastName;
        paxDetails.PaxMobileNo = this.state.mobileNumber;
        paxDetails.PaxPuStopId = parseInt(this.state.stopId);
        paxDetails.PaxDoStopId = 0;
        paxDetails.PaxAdultNo = paxCount;
        //paxDetails.PaxPuDateTime = this.state.puDateTime.toLocaleDateString() + " " + this.state.puDateTime.toLocaleTimeString();
        paxDetails.PaxPuDateTime = moment(new Date(this.state.puDateTime)).format(DateFormat.MomentDisplayDateTime24Format);
        paxDetails.PaxCreatedBy = parseInt(sessionStorage.getItem("session_userId"));
        paxDetails.PaxPuLatitude = 0;
        paxDetails.PaxPuLongitude = 0;
        paxDetails.PaxDoLatitude = 0;
        paxDetails.PaxDoLongitude = 0;

        var tripPaxDetails = [];
        tripPaxDetails[0] = paxDetails;
        newObject.tripPaxDetails = [];
        newObject.tripPaxDetails = tripPaxDetails;

        //console.log("newObject: " + JSON.stringify(newObject));

        try {
            //this.props.submitFunction(true);

            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('reservation-api/book', requestParams);
            const data = await response.json();

            let strAlert = "";

            if (!data.isSuccess) {
                if (data.retValue == -2000) {
                    strAlert = data.resultMessage;
                } else {
                    strAlert = "Reservation failed due to server error.";
                }
            } else {
                if (this.state.rideId <= 0) {
                    if (this.state.parentAccountId === 6052) {
                        if (this.state.pickupLocationSource.displayName === "Edmonton International Airport") {
                            strAlert = "See you in 15-20 min at door no 10 Arrivals. Your confirmation number is: ";
                        }
                        else {
                            strAlert = "See you in 15-20 min. Your confirmation number is: ";
                        }                        
                    }
                    else {
                        strAlert = "Your confirmation number is: ";
                    }

                } else {
                    strAlert = "Your booking has been modify and updated successfully.";
                }
                strAlert += "\t" + data.tripResult[0].tripId + "";
                //strAlert += "Thank you for booking.";
            }

            this.setState({
                isSaveSubmited: false,
                isBookingSaved: true,
                bookingMessage: strAlert,
                isSuccess: data.isSuccess,
            });

            //Swal.fire({
            //    icon: data.isSuccess ? 'success' : 'error',
            //    title: data.isSuccess ? 'Success' : 'Oops...',
            //    html: strAlert,
            //    width: '25%',
            //    allowOutsideClick: false
            //}).then((result) => {
            //    /* Read more about isConfirmed, isDenied below */
            //    if (data.isSuccess) {
            //        if (result.isConfirmed) {
            //            this.clearControls();
            //            //this.props.submitFunction(false);
            //            //if (this.state.rideId <= 0) {
            //            //    if (this.state.isCopy == true) {
            //            //        if (this.state.isAttachment == true) {
            //            //            var rideArray = [];
            //            //            for (var i = 0; i < data.tripResult.length; i++) {
            //            //                rideArray.push(data.tripResult[i].tripId);
            //            //            }
            //            //            this.props.attachmentUpload(rideArray);

            //            //        } else if (this.state.isSendEmail == true) {

            //            //            this.props.openEmailModal(this.state.puDateTime, data.tripResult[0].tripId, this.state.email)
            //            //        } else {
            //            //            this.props.goToBackPage(); // method defined in BookingComponent
            //            //        }
            //            //    } else {
            //            //        if (this.state.isAttachment == true) {
            //            //            var rideArray = [];
            //            //            for (var i = 0; i < data.tripResult.length; i++) {
            //            //                rideArray.push(data.tripResult[i].tripId);
            //            //            }
            //            //            this.props.attachmentUpload(rideArray);
            //            //        } else if (this.state.isSendEmail == true) {

            //            //            this.props.openEmailModal(this.state.puDateTime, data.tripResult[0].tripId, this.state.email)
            //            //        }
            //            //        this.clearControls();
            //            //    }
            //            //} else {
            //            //    if (this.state.isAttachment == true) {
            //            //        var rideArray = [];
            //            //        rideArray.push(this.state.rideId);
            //            //        //this.props.attachmentUpload(rideArray);

            //            //    } else {
            //            //        // this.props.goToBackPage(); // method defined in BookingComponent
            //            //    }
            //            //}
            //        }
            //    } else {
            //        //this.props.submitFunction(false);
            //    }
            //})

        } catch (e) {
            //this.props.submitFunction(false);
        }
    }

    handleEditAddPassenger(e, data) {
        e.preventDefault();
        this.setState({
            isPaxUpdate: true,
            isOpenModal: true,
            rowIndex: data.rowIndex,
            paxFirstName: data.firstName,
            paxLastName: data.lastName,
            mobileNumber: data.mobile,
            email: data.email,
            noOfPax: data.pax,
            scheduleId: this.state.scheduleId,
            stopScheduleId: data.routeStopScheduleId,
        });
    }

    async handleCancelPassenger(e, data) {
        e.preventDefault();

        //this.setState({
        //    isPaxUpdate: true,
        //    isOpenModal: true,
        //    rowIndex: data.rowIndex,
        //    paxFirstName: data.firstName,
        //    paxLastName: data.lastName,
        //    mobileNumber: data.mobile,
        //    email: data.email,
        //    noOfPax: data.pax,
        //    scheduleId: this.state.scheduleId,
        //    stopScheduleId: data.routeStopScheduleId,
        //});

        var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
        var pickupDate = [];
        pickupDate.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1)
            : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0"
                + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear() + " " + this.state.pickupTime);

        var newObject = new Object();
        let paxCount = (parseInt(data.pax | 0));
        newObject.rowIndex = data.rowIndex;
        newObject.accountId = this.state.customer.id;
        newObject.rideId = this.state.rideId;
        newObject.paxCount = paxCount;
        newObject.paxFirstName = data.firstName;
        newObject.paxLastName = data.lastName;
        newObject.mobile = data.mobile;
        newObject.email = data.email;
        newObject.pax = paxCount;
        newObject.puStopId = this.state.stopId;
        newObject.doStopId = parseInt(0);
        newObject.createdBy = parseInt(sessionStorage.getItem("session_userId"));
        newObject.pickupDateTime = pickupDate[0];
        newObject.isCancelled = true;

        const requestParams = getRequestParams('POST', newObject);
        const response = await fetch('reservation-api/addEditPassengerDetails', requestParams);
        const resultset = await response.json();

        //this.setState({
        //    isSaveSubmited: false,
        //    isBookingSaved: true,
        //    bookingMessage: resultset.resultMessage,
        //});

        Swal.fire({
            icon: resultset.isSuccess ? 'success' : 'error',
            title: resultset.isSuccess ? 'Success' : 'Oops...',
            html: resultset.resultMessage,
            width: '25%',
            allowOutsideClick: false
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (resultset.isSuccess) {
                if (result.isConfirmed) {
                    this.getRidePassengerDetails(this.state.rideId);
                    this.clearControls();
                }
            }
        });
    }

    handleScheduleTimeChange = async (e) => {
        //if (e.selectedItem != null) {
        //    var pickupTime = e.selectedItem.scheduleTime;
        //    var newpickupDate = formatDate(this.state.puDateTime, "MM/dd/yyyy");
        //    var schedulepickupDate = new Date(newpickupDate + ' ' + pickupTime + ':00');

        //    var request = {};
        //    request.ReservationId = parseInt(e.selectedItem.reservationId);
        //    request.RideId = parseInt(0);
        //    request.ScheduleTime = e.selectedItem.scheduleTime;

        //    await setTimeout(() => this.getRideOnScheduleTime(request), 1000);

        //    var requestPickupTime = {};
        //    requestPickupTime.RowIndex = 0;
        //    requestPickupTime.RouteScheduleId = parseInt(e.selectedItem.scheduleId);
        //    requestPickupTime.RouteStopId = 0;
        //    requestPickupTime.ScheduleGroupId = parseInt(e.selectedItem.schedulesGroupId);
        //    requestPickupTime.ScheduleTime = e.selectedItem.scheduleTime;

        //    await setTimeout(() => this.getRideOnScheduleActualPickupTime(requestPickupTime), 1000);

        //    this.setState({
        //        scheduleId: e.selectedItem.scheduleId,
        //        scheduleTime: e.selectedItem.scheduleTime,
        //        puDateTime: schedulepickupDate,
        //        routeSchedulesGroupId: e.selectedItem.schedulesGroupId,
        //    });
        //}
    }

    async getServiceAreaZoneList() {
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('serviceAreaZone-api/service-area-zone-place/0/' + this.state.parentAccountId, requestParams);
        const data = await response.json();
        if (data !== null && data.serviceAreaZonePlace.length > 0) {
            var airportLocations = data.serviceAreaZonePlace.filter(e => e.zoneTypeId === 1);

            this.setState({
                placeGridDataSource: airportLocations
            });
        }
    }

    handlePickupChange = async (e, value) => {
        e.preventDefault();
        let pickupTypeId = parseInt(value);
        if (pickupTypeId === 1) {
            let suggestionValue = this.state.customerName.substring(0, 7);
            //await this.getAirportSuggestions("YEG");
            await this.getServiceAreaZoneList();
            await this.getBookingSuggestions(suggestionValue);
        }

        this.setState({
            rideTypeId: pickupTypeId,
            puDateTime: currentTime,
        });
    }

    handlePickupTimeChange = async (e) => {
        if (e.selectedItem != null) {
            var request = {};
            request.ReservationId = parseInt(e.selectedItem.reservationId);
            request.RideId = parseInt(0);
            request.ScheduleTime = moment(this.state.puDateTime).format("MM/DD/YYYY") + " " + e.selectedItem.scheduleTime
            await setTimeout(() => this.getRideOnScheduleTime(request), 1000);

            this.setState({
                stopScheduleId: e.selectedItem.stopScheduleId,
                pickupTime: e.selectedItem.actualPickupTime,
                scheduleId: e.selectedItem.scheduleId,
            });
        }
    }

    getRideOnScheduleActualPickupTime = async (rideDayId) => {
        try {
            var request = {};
            request.RowIndex = 0;
            request.RouteScheduleId = 0;
            request.RouteStopId = parseInt(sessionStorage.getItem("session_stop_id"));
            request.ScheduleGroupId = 0;
            request.ScheduleTime = "";

            const requestParams = getRequestParams('POST', request);
            const response = await fetch('/shuttle-schedule-api/schedule-actual-pickuptime', requestParams);
            const data = await response.json();

            if (data !== null) {
                if (data?.scheduleActualPickupTime !== null) {
                    //console.log(currentTime);
                    //console.log(currentExactTime);
                    var dt1 = new Date(currentExactTime);
                    var dt2 = new Date(currentTime);
                    var time_difference = dt2.getTime() - dt1.getTime();
                    var result = time_difference / (1000 * 60 * 60 * 24);
                    var actualPickupTime = [];

                    if (rideDayId === 1) {
                        if (result > 0) {
                            actualPickupTime = data?.scheduleActualPickupTime.filter(f => f.actualPickupTime >= this.state.defaultCurrentTime);
                        }
                    }
                    else {
                        actualPickupTime = data?.scheduleActualPickupTime;
                    }

                    this.setState({
                        scheduleActualPickupTime: actualPickupTime,
                    });
                }
            }
        }
        catch (ex) {
            console.log(ex);
        }
    }

    getRideOnScheduleTime = async (request) => {
        try {
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('/reservation-api/ride-on-schedule-time', requestParams);
            const data = await response.json();
            if (data.rideOnScheduleTime.length > 0) {
                //await setTimeout(() => this.getRidePassengerDetails(data?.rideOnScheduleTime[0]?.rideId), 500);
                this.setState({
                    rideId: data?.rideOnScheduleTime[0]?.rideId,
                });
            }
            else {
                this.setState({
                    rideId: 0,
                });
            }
        }
        catch (ex) {
            console.log(ex);
        }
    }

    //async handleRezSubmit(e) {
    //    e.preventDefault();
    //    this.refs.hotelTransferRef.hotelTransferSubmit(false, false);
    //}

    handleRideTypeChange = async (e) => {
        if (e.value === 1) {
            //await this.getAirportSuggestions("YEG");
            await this.getServiceAreaZoneList();
            await this.getBookingSuggestions(this.state.customerName);
        }

        this.setState({
            rideTypeId: e.value,
        });
    }

    handleDayTypeChange = async (e) => {
        if (e.selectedItem !== null) {
            let nextDate = moment(this.state.puDateTime).add(1, 'days').format("MM/DD/YYYY HH:mm");

            await setTimeout(() => this.getRideOnScheduleActualPickupTime(e.value), 500);
            await setTimeout(() => this.getRidePassengerDetails(0, e.value), 500);
            this.setState({
                rideDayId: e.value,
                puDateTime: e.value === 1 ? currentTime : nextDate,
            });
        }
    }

    handlePickupDateTimeChange = async (date) => {
        this.setState({ puDateTime: date.value });
        this.state.errors["puDateTime"] = "";
    }

    handlePickupLocationChange = async (e) => {
        this.setState({ pickupLocationId: e.selectedItem !== null ? e.selectedItem.id : 0 });
        this.setState({ pickupLocationSource: e.selectedItem !== null ? e.selectedItem : [] });
        
        if (e.selectedItem !== null) {
            this.state.errors["pickupLocationId"] = "";
            var selectedPickupLocation = e.selectedItem;

            this.setState({
                pickupLocation: selectedPickupLocation.displayName,
                pickupAddress: selectedPickupLocation.displayName,
                pickupAddressType: "Airport",
                pickupCity: selectedPickupLocation.city,
                pickupState: selectedPickupLocation.state,
                pickupZipCode: selectedPickupLocation.zipCode,
                pickupZoneId: selectedPickupLocation.serviceAreaZoneId,
                pickupLatitude: selectedPickupLocation.latitude,
                pickupLongitude: selectedPickupLocation.longitude,
                pickupZoneTypeId: selectedPickupLocation.zoneTypeId,
            });
        }
    }

    render() {
        const renderGridCell = (data) => {
            var dt1 = new Date(this.state.puDateTime);
            var dt2 = new Date(data.data.pickupDateTime);
            var time_difference = dt2.getTime() - dt1.getTime();
            var result = time_difference / (1000 * 60);
            return <div>
                <a href="#" className="fas fa-times icon text-info" title="Update" onClick={(e) => { this.handleCancelPassenger(e, data.data) }} ></a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{result > 30 &&
                    <a href="#" className="fas fa-pen icon text-info" title="Update" onClick={async (e) => { await this.handleEditAddPassenger(e, data.data) }} ></a>}
            </div>;
        }

        return (
            <div className="content">

                <div className="rez-container">
                    <div className="card main-rez-card">
                        <div className="card-body">
                            {
                                this.state.isBookingSaved === true &&
                                <div>
                                    <div className="container-fluid pt-2 mt-10">
                                        <div className="row">
                                            <div
                                                className="row"
                                                style={{
                                                    height: "20vh",
                                                    width: "100%",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    border: "1px solid #cfcfcf",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <div className="text-center">
                                                    <div class="" role="alert">
                                                        <p>
                                                            <p>
                                                                {this.state.bookingMessage}
                                                            </p>
                                                            {this.state.isSuccess === true &&
                                                                <h4>
                                                                    Thank you for booking.
                                                                </h4>
                                                            }
                                                        </p>
                                                        <button
                                                            onClick={() => {
                                                                window.location.href = `/hotel-booking`;
                                                            }}
                                                            className="btn btn-primary go-home-btn"
                                                        >
                                                            Go Home
                                                        </button>
                                                        <br />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.isBookingSaved === false &&
                                <>
                                    <div className="row">
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <div className="form-group">
                                                <label htmlFor="">Choose Pickup</label><br />
                                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                                    <label class="btn btn-outline-success btn-lg p-2">
                                                        <input type="radio" id="radAirport"
                                                            onClick={async (e) => { await this.handlePickupChange(e, 1) }}
                                                        />
                                                        <i className="fas fa-plane-departure"></i><b> Airport Pickup </b></label>
                                                    <label class="btn btn-outline-success btn-lg p-2 active">
                                                        <input type="radio" id="radHotel"
                                                            onClick={async (e) => { await this.handlePickupChange(e, 2) }}
                                                            checked="true"
                                                        />
                                                        <i className="fas fa-hotel"></i><b> Hotel Pickup </b></label>
                                                </div>
                                                {/*<RadioGroup*/}
                                                {/*    id="radio-group-with-selection"*/}
                                                {/*    items={rideTypeEntities}*/}
                                                {/*    value={this.state.rideTypeId}*/}
                                                {/*    valueExpr="id"*/}
                                                {/*    displayExpr="text"*/}
                                                {/*    onValueChanged={async (e) => { await this.handleRideTypeChange(e) }}*/}
                                                {/*    layout="horizontal"*/}
                                                {/*/>*/}
                                            </div>
                                        </div>
                                        {this.state.rideTypeId === 2 && <>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                <div className="form-group">
                                                    <label htmlFor="">&nbsp;</label>
                                                    <RadioGroup
                                                        id="radio-group-ride-day"
                                                        items={rideDayEntities}
                                                        value={this.state.rideDayId}
                                                        valueExpr="id"
                                                        displayExpr="text"
                                                        onValueChanged={async (e) => { await this.handleDayTypeChange(e) }}
                                                        layout="horizontal"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        }
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 displayNone">
                                            <div className="form-group">
                                                <label>Select Customer <span className="text-danger">*</span></label>
                                                <SelectBox
                                                    dataSource={this.state.dropdownCustomer.length > 0 ? this.state.dropdownCustomer : []}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    placeholder="Select customer"
                                                    name="customerId"
                                                    defaultValue={0}
                                                    value={this.state.customerId}
                                                    displayExpr='fullName'
                                                    valueExpr='id'
                                                    onSelectionChanged={this.handleCustomerChange}
                                                    showClearButton={true}
                                                    //disabled={this.state.rideId <= 0 ? false : true}
                                                    searchEnabled={true}
                                                />
                                                {/*{this.state.errors["pickupLocationId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["pickupLocationId"]}</span>}*/}
                                            </div>
                                        </div>
                                        {this.state.rideTypeId === 1 &&
                                            <>
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 displayNone">
                                                    <div className="form-group">
                                                        <label>PU Date and Time  <span className="text-danger">*</span></label>
                                                        <DateBox
                                                            type={"datetime"}
                                                            className="form-control form-control-sm"
                                                            name="puDateTime"
                                                            placeholder={"MM/dd/yyyy HH:mm"}
                                                            displayFormat={"MM/dd/yyyy HH:mm"}
                                                            showAnalogClock={true}
                                                            useMaskBehavior={true}
                                                            defaultValue={this.state.puDateTime}
                                                            value={this.state.puDateTime}
                                                            onValueChanged={async (e) => { this.handlePickupDateTimeChange(e) }}
                                                            width="100%"
                                                            disabled={false}
                                                            acceptCustomValue={false}
                                                        />
                                                        {this.state.errors["puDateTime"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["puDateTime"]}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                                    <div className="form-group">
                                                        <label>Pickup Time</label><br />
                                                        <label><b><h5>{this.state.actualPuTime}</h5></b></label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                    <div className="form-group">
                                                        <label>Select Pickup Location <span className="text-danger">*</span></label>
                                                        <SelectBox
                                                            dataSource={this.state.placeGridDataSource.length > 0 ? this.state.placeGridDataSource : []}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            placeholder="Select Pickup Location"
                                                            name="id"
                                                            value={this.state.pickupLocationId}
                                                            displayExpr='displayName'
                                                            valueExpr='id'
                                                            onSelectionChanged={async (e) => { await this.handlePickupLocationChange(e) }}
                                                            showClearButton={true}
                                                            disabled={this.state.isPaxUpdate}
                                                            searchEnabled={true}
                                                        />
                                                        {this.state.errors["pickupLocationId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["pickupLocationId"]}</span>}
                                                </div>
                                            </div>
                                            </>
                                        }
                                        {this.state.rideTypeId === 2 &&
                                            <>
                                                <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 displayNone">
                                                    <div className="form-group">
                                                        <label htmlFor="">Schedule Time  <span className="text-danger">*</span></label>
                                                        <SelectBox
                                                            dataSource={this.state.shuttleScheduleSource.length > 0 ? this.state.shuttleScheduleSource : []}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            placeholder="Select Schedule"
                                                            name="scheduleId"
                                                            value={this.state.scheduleId}
                                                            displayExpr='scheduleTime'
                                                            valueExpr='scheduleId'
                                                            onSelectionChanged={async (e) => { await this.handleScheduleTimeChange(e) }}
                                                            showClearButton={true}
                                                            disabled={this.state.isPaxUpdate}
                                                            searchEnabled={true}
                                                        />
                                                        {this.state.errors["scheduleTime"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["scheduleTime"]}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                    <div className="form-group">
                                                        <label htmlFor="">Pickup Time <span className="text-danger">*</span></label>
                                                        <SelectBox
                                                            dataSource={this.state.scheduleActualPickupTime.length > 0 ? this.state.scheduleActualPickupTime : []}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            placeholder="Select Pickup time"
                                                            name="stopScheduleId"
                                                            value={this.state.stopScheduleId}
                                                            displayExpr='actualPickupTime'
                                                            valueExpr='stopScheduleId'
                                                            onSelectionChanged={async (e) => { await this.handlePickupTimeChange(e) }}
                                                            showClearButton={true}
                                                            disabled={this.state.isPaxUpdate}
                                                            searchEnabled={true}
                                                        />
                                                        {this.state.errors["pickupTime"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["pickupTime"]}</span>}
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <div className="form-group">
                                                <label>Passenger First Name <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control form-control-sm" maxLength={50} value={this.state.paxFirstName} onChange={this.handleInputChange} name="paxFirstName" />
                                                {this.state.errors["paxFirstName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paxFirstName"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <div className="form-group">
                                                <label>Passenger Last Name <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control form-control-sm" maxLength={50} value={this.state.paxLastName} onChange={this.handleInputChange} name="paxLastName" />
                                                {this.state.errors["paxLastName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paxLastName"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                            <div className="form-group">
                                                <label>Mobile Number <span className="text-danger">*</span></label>
                                                <NumberFormat className="form-control form-control-sm" name="mobileNumber" placeholder="(000) 000-0000" title="Mobile Number" value={this.state.mobileNumber} onChange={this.handleInputChange} format="(###) ###-####" />
                                                {this.state.errors["mobileNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["mobileNumber"]}</span>}
                                            </div>
                                        </div>
                                        {/*<div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">*/}
                                        {/*    <div className="form-group">*/}
                                        {/*        <label>Email</label>*/}
                                        {/*        <input type="text" className="form-control form-control-sm" name="email" placeholder="test@domain.com" maxLength="100" title="Email" value={this.state.email} onChange={this.handleInputChange} />*/}
                                        {/*        {this.state.errors["email"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["email"]}</span>}*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                            <div className="form-group">
                                                <label>Passenger# <span className="text-danger">*</span></label>
                                                <NumericInput className="form-control form-control-sm" name="noOfPax" title="Number of Pax" value={this.state.noOfPax} min={1} max={100} onChange={(value) => { this.handlePaxCountChange(value) }} />
                                                {this.state.errors["noOfPax"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["noOfPax"]}</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        {this.state.rideTypeId === 1 &&
                                            <div>
                                                {this.state.isPaxUpdate === false && (
                                                    <button type="button" className="btn btn-primary" onClick={(e) => { this.handleBookReservation(e) }} >
                                                        {this.state.isSaveSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                                        {!this.state.isSaveSubmited && <span title="Save"><i className="fas fa-save"></i> Book Now</span>}
                                                    </button>)}&nbsp;
                                                <button type="button" className="btn btn-outline-primary" onClick={(e) => { this.clearControls(e) }} >
                                                    <span title="In-process"><i className="fas fa fa-pen"></i> Clear</span>
                                                </button>
                                            </div>
                                        }
                                        {this.state.rideTypeId === 2 &&
                                            <div>
                                                {this.state.isPaxUpdate === false && (
                                                    <button type="button" className="btn btn-primary" onClick={(e) => { this.hotelPaxDetailsSubmit(e, false, false) }} >
                                                        {this.state.isSaveSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                                        {!this.state.isSaveSubmited && <span title="Save"><i className="fas fa-save"></i> Book Now</span>}
                                                    </button>)}&nbsp;
                                                {this.state.isPaxUpdate === true && (
                                                    <button type="button" className="btn btn-primary" onClick={(e) => { this.hotelPaxDetailsSubmit(e, false, false) }} >
                                                        {this.state.isSaveSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                                        {!this.state.isSaveSubmited && <span title="Save"><i className="fas fa-save"></i> Update</span>}
                                                    </button>)}&nbsp;
                                                <button type="button" className="btn btn-outline-primary" onClick={(e) => { this.clearGridControls(e) }} >
                                                    <span title="In-process"><i className="fas fa fa-pen"></i> Clear</span>
                                                </button>
                                            </div>
                                        }
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <DataGrid
                                            id="passengerdetails-grid-container"
                                            dataSource={this.state.passengerdatasource}
                                            columnsAutoWidth={true}
                                            showColumnLines={true}
                                            showRowLines={true}
                                            showBorders={true}
                                            width="auto"
                                            rowAlternationEnabled={true}
                                            allowColumnResizing={true}
                                            columnResizingMode='widget'
                                            showBorders={true}>

                                            <Column dataField="id" caption="" width={"auto"} allowFiltering={false} allowSorting={false} cellRender={renderGridCell} visible={this.state.rideTypeId === 2 ? true : false} />
                                            <Column dataField="firstName" caption="First Name" allowFiltering={false} allowSorting={false} />
                                            <Column dataField="lastName" caption="Last Name" allowFiltering={false} allowSorting={false} />
                                            <Column dataField="pax" caption="Passenger(s)" width={120} allowFiltering={true} allowSorting={true} />
                                            <Column dataField="pickupDateTime" caption="Pick-up Time" allowFiltering={false} allowSorting={true} format={DateFormat.DateTime24Format} dataType="datetime" />
                                            {/*<Column dataField="email" caption="Email" width={"250px"} allowFiltering={false} allowSorting={false} />*/}
                                            <Column dataField="mobile" caption="Mobile" allowFiltering={false} allowSorting={false} />

                                            <SortByGroupSummaryInfo summaryItem="count" />
                                            <GroupPanel visible={false} />
                                            <HeaderFilter visible={true} />
                                            <SearchPanel visible={true} highlightCaseSensitive={false} width={600} placeholder="Search..." />
                                            <Grouping autoExpandAll={false} />
                                            <Paging defaultPageSize={10} />
                                            <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50, 500]} showInfo={true} visible={true} />
                                            <Export enabled={true} allowExportSelectedData={false} />
                                            <ColumnChooser enabled={false} />
                                            <ColumnFixing enabled={true} />
                                        </DataGrid>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
                {/*<button type="button" className="btn btn-success btn-sm" onClick={(e) => { this.handleRezSubmit(e, false, false) }} >*/}
                {/*    {this.state.isRezSaveSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}*/}
                {/*    {!this.state.isRezSaveSubmited && <span title="Save"><i className="fas fa-save"></i> Save</span>}*/}
                {/*</button><br />*/}
                {/*<HotelServiceTransferComponent ref="hotelTransferRef" attachmentUpload={this.attachmentUpload} openEmailModal={this.openEmailModal}*/}
                {/*    submitFunction={this.submitFunction} duplicateFunction={this.duplicateFunction} customer={this.state.customer}*/}
                {/*    tripDetails={this.state.tripDetails} goToBackPage={this.goToBackPage} />*/}
                {/*<LoadPanel*/}
                {/*    shadingColor="rgba(0,0,0,0.4)"*/}
                {/*    position={position}*/}
                {/*    visible={this.state.loadPanelVisible}*/}
                {/*    showIndicator={true}*/}
                {/*    shading={true}*/}
                {/*    showPane={true}*/}
                {/*    closeOnOutsideClick={false}*/}
                {/*/>*/}

                {this.state.loadPanelVisible && <PageLoaderComponent loadingMessage={this.state.loadingMessage} />}
            </div>
        );
    }
}